var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{class:_vm.iconAttr.class,attrs:{"size":"22","icon":_vm.iconAttr.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }